import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ProductCollection} from 'types/product-collection';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getProductCollection = api.injectEndpoints({
  endpoints: builder => ({
    getProductCollection: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `product-variants/collections`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{product_collections: ProductCollection[]}>;

export const {useGetProductCollectionQuery} = getProductCollection;
